
import React, { Component } from 'react';
import { Modal, Button, Descriptions, Divider, Row, Table } from 'antd';

const fields = [{
    "text": "账单编号",
    "field": "orderId",
},{
    "text": "退款编号",
    "field": "refundOrderId",
},  {
    "text": "账单类型",
    "field": "typeStr",
},  {
    "text": "账单类型业务编号",
    "field": "typeId",
},  {
    "text": "商户号",
    "field": "mid",
},  {
    "text": "终端号",
    "field": "tid",
}, {
    "text": "微信用户openid",
    "field": "subOpenId",
}, {
    "text": "支付金额",
    "field": "totalAmountD",
}, {
    "text": "退款金额",
    "field": "refundAmountD",
}, {
    "text": "账单状态",
    "field": "statusStr",
}, {
    "text": "退款状态",
    "field": "refundStatusStr",
}, {
    "text": "付款人",
    "field": "creatorName",
}, {
    "text": "退款操作人",
    "field": "refundOperatorName",
}, {
    "text": "账单创建时间",
    "field": "insertTime"
}, {
    "text": "退款时间",
    "field": "refundTime",
}, {
    "text": "付款时间",
    "field": "payTime",
}, {
    "text": "账单备注",
    "field": "orderDesc",
}];


class FinancialAuditDetail extends Component {
    columns = [{
        title: '操作类型',
        dataIndex: 'type',
        width: '10%',
    },{
        title: '操作人',
        dataIndex: 'operator',
        width: '10%',
    },{
        title: '操作时间',
        dataIndex: 'createTime',
        width: '15%',
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '20%',
    }];

    render() {
        const { visible, onCancel, editData } = this.props;
        const businessData = editData.businessData;
        return (
            <Modal
                width={900}
                visible={visible}
                title="微信支付信息详情"
                maskClosable={false}
                onCancel={onCancel}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Divider orientation="left">账单基本信息</Divider>
                <Descriptions title="" bordered column={2}>
                    {fields.map((item, index) => {
                        let val = editData[item.field]
                        if (item.format) {
                            val = item.format[val];
                        }
                        return <Descriptions.Item key={index} label={item.text}>{val}</Descriptions.Item>;
                    })}
                </Descriptions>
                <Divider orientation="left">账单关联业务相关信息</Divider>
                {businessData ? <Descriptions title="" bordered column={2}>
                    {businessData.map((item, index) => {
                        return <Descriptions.Item key={index} label={item.label}>{item.value}</Descriptions.Item>;
                    })}
                </Descriptions> : ""}
                <Row>
                    <Divider orientation="left">退款操作记录列表</Divider>
                    <Table
                        rowKey="id"
                        columns={this.columns}
                        dataSource={this.props.editData.payOrderLogs}
                        pagination={{ pageSize: 5 }}
                        bordered={true}
                    />
                </Row>
            </Modal>
        );
    }
}


export default FinancialAuditDetail;